const TOAST_ROOT_ID = 'manteo-toast-root';
const DEFAULT_DURATION_MS = 3200;

const VARIANT_CLASSES = {
  success: 'bg-emerald-500/70 border-emerald-300/40 text-emerald-50',
  error: 'bg-rose-500/70 border-rose-300/40 text-rose-50',
  info: 'bg-slate-800/70 border-slate-500/40 text-slate-50'
};

const getToastRoot = () => {
  let root = document.getElementById(TOAST_ROOT_ID);
  if (root) return root;

  root = document.createElement('div');
  root.id = TOAST_ROOT_ID;
  root.className = 'fixed top-4 right-4 z-[120] flex flex-col gap-2.5 pointer-events-none';
  document.body.appendChild(root);
  return root;
};

export const showToast = (message, options = {}) => {
  if (typeof window === 'undefined' || !message) return;

  const { variant = 'info', duration = DEFAULT_DURATION_MS } = options;
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.info;
  const root = getToastRoot();

  const toast = document.createElement('div');
  toast.setAttribute('role', 'status');
  toast.className = [
    'pointer-events-auto',
    'min-w-[280px] max-w-[420px]',
    'px-4 py-3 rounded-2xl border',
    'backdrop-blur-md supports-[backdrop-filter]:backdrop-blur-md',
    'shadow-[0_10px_30px_-12px_rgba(15,23,42,0.6)]',
    'ring-1 ring-white/10',
    'text-[10px] font-black uppercase tracking-[0.16em] leading-relaxed',
    'animate-in slide-in-from-top-3 fade-in-0 zoom-in-95 duration-200',
    variantClass
  ].join(' ');
  toast.textContent = message;
  root.appendChild(toast);

  window.setTimeout(() => {
    toast.classList.add(
      'opacity-0',
      '-translate-y-1',
      'scale-[0.98]',
      'blur-[1px]',
      'transition-all',
      'duration-200'
    );
    window.setTimeout(() => toast.remove(), 220);
  }, duration);
};

export const showSuccessToast = (message) => showToast(message, { variant: 'success' });
export const showErrorToast = (message) => showToast(message, { variant: 'error' });
export const showInfoToast = (message) => showToast(message, { variant: 'info' });
